var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"img-cover"},[_c('img',{attrs:{"src":_vm.imgUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }